








import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class UnauthorizedPage extends Vue {
  back() {
    this.$router.go(-1);
  }
}
